import { Component, Input } from '@angular/core';

@Component({
  selector: 'rank-badge',
  standalone: true,
  imports: [],
  templateUrl: './rank-badge.component.html',
  styleUrl: './rank-badge.component.scss'
})
export class RankBadgeComponent {
  @Input() rank: number = 0;
}
